@if (loadingTravellerProfile) {
  <app-loading-screen>
    <span title i18n="@@SearchLoadingTravellerProfilw">Fetching Traveller Profile</span>
  </app-loading-screen>
}
@if (loadingSSO) {
  <app-loading-screen>
    <span title i18n="@@mainPerformingSearch">Performing search ...</span>
  </app-loading-screen>
}
<div class="app">
  <app-results-header [blank]="true" page="search"></app-results-header>

  <!-- Reusable menu template -->
  <ng-template #sideMenuTemplate let-suffix="suffix">
    <div
      class="app-right secondary-text-colour"
      [@slideInOut]="basketService.menuState"
      [id]="'side-menu' + (suffix || '')"
      #basket
    >
      <button
        tabindex="0"
        aria-label="Menu"
        [id]="'basket_expander_button' + (suffix || '')"
        [attr.aria-expanded]="basketService.menuState === MenuSlideEnum.IN"
        type="button"
        #basketExpanderButton
        (click)="openRightPanelMenu(selectedRightPanelItem); toggleMenu()"
        class="basket-button"
      >
        <i class="ico-lines" aria-hidden="true"></i>
      </button>
      <div class="menu" [ngClass]="{ show: basketService.menuState === MenuSlideEnum.IN }">
        <mat-tab-group>
          <mat-tab [id]="'recent-searches-tab' + (suffix || '')">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="faClockRotateLeft"
                ngbTooltip="Recent Searches"
                i18n-ngbTooltip="@@searchRecentSearches"
                placement="bottom"
                container="body"
                aria-hidden="true"
              ></fa-icon>
              <span class="visuallyhidden" i18n="@@searchRecentSearchesSpan">Recent Searches</span>
            </ng-template>
            <app-recent-searches
              [hidden]="loadingTravellerProfile"
              class="app-recent-searches"
            ></app-recent-searches>
          </mat-tab>
          <mat-tab [id]="'my-baskets-tab' + (suffix || '')" #basketTab>
            <ng-template mat-tab-label>
              @if (displayItinerary) {
                <img
                  class="luggage_icon"
                  src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/luggage_icon.svg"
                  alt=""
                  ngbTooltip="My Itineraries"
                  i18n-ngbTooltip="@@searchMyItineraries"
                  placement="bottom"
                  container="body"
                  aria-hidden="true"
                />
                <span class="visuallyhidden" i18n="@@searchItinerariesSpan">My Itineraries</span>
              } @else {
                <i
                  class="material-icons"
                  ngbTooltip="My Baskets"
                  i18n-ngbTooltip="@@searchMyBaskets"
                  placement="bottom"
                  container="body"
                  aria-hidden="true"
                  >shopping_basket</i
                >
                <span class="visuallyhidden" i18n="@@searchBasketsSpan">My Baskets</span>
              }
            </ng-template>
            <app-basket-panel
              [searchPage]="true"
              class="app-basket-panel background-container-background"
              (click)="onPanelClick($event)"
            ></app-basket-panel>
          </mat-tab>
          <mat-tab [id]="'frequent-travellers-tab' + (suffix || '')">
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="faUser"
                ngbTooltip="Frequent Travellers"
                i18n-ngbTooltip="@@searchFrequentTravellers"
                placement="bottom"
                container="body"
                aria-hidden="true"
              ></fa-icon>
              <span class="visuallyhidden" i18n="@@searchFrequentTravellersSpan"
                >Frequent Travellers</span
              >
            </ng-template>
            <app-frequent-travellers></app-frequent-travellers>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
              <fa-icon
                [icon]="faStar"
                ngbTooltip="Favourite Searches"
                i18n-ngbTooltip="@@searchFavouriteSearches"
                placement="bottom"
                container="body"
                aria-hidden="true"
              ></fa-icon>
              <span class="visuallyhidden" i18n="@@searchFavouriteSearchesSpan"
                >Favourite Searches</span
              >
            </ng-template>
            <app-favorite-items></app-favorite-items>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </ng-template>

  @if (
    {
      allUserdata: userService.fullUserDetails.allDetails | async,
      services: userServices$ | async,
      errors: searchService.errors | async,
      loadingDate: searchService.loadingDate | async
    };
    as data
  ) {
    <div class="app-body wcag-checkbox" id="main" #main>
      <div class="menu-container">
        <section class="app-full-width secondary-text-colour">
          @if (userIsAgent) {
            <app-banner [target]="displayTarget" [agentOnly]="true"></app-banner>
          }
          <app-banner [target]="displayTarget"></app-banner>
          <app-announcements
            [basketStatus]="0"
            page="search"
            [serviceType]="searchService.searchTypes"
          >
          </app-announcements>
          @if (!showGuestTravellerForm) {
            <h1
              id="search"
              class="search_content_titles"
              i18n="@@searchTitle"
              aria-label="New Search, please select the product(s) you would like to book."
            >
              New Search<span class="visuallyhidden"
                >, please select the product(s) you would like to book.</span
              >
            </h1>
          }
          @if (showPaymentWarning) {
            <p>
              This user does not have a stored credit card in their profile. You can only book
              services that are assigned to other payment methods. Please select an eligible service
              or update the payment details.
            </p>
          }
          @if (!showGuestTravellerForm) {
            <div class="booking_panel_options background-container-background">
              @if (themeService.isLightningEnv) {
                <div
                  class="booking_options booking_group"
                  role="group"
                  aria-label="Combo booking options"
                >
                  @if (data?.services?.[ServiceType.Rail] && data?.services?.[ServiceType.Hotel]) {
                    <app-product-checkbox
                      class="booking_options_option"
                      [service]="ServiceType.Rail"
                      [disabled]="
                        !data.services?.[ServiceType.Rail] ||
                        !data.services?.[ServiceType.Hotel] ||
                        paymentRestrictions[ServiceType.Rail] ||
                        paymentRestrictions[ServiceType.Hotel]
                      "
                      [isPaymentRestrictedDueToNoCard]="
                        paymentRestrictions[ServiceType.Rail] ||
                        paymentRestrictions[ServiceType.Hotel]
                      "
                      [comboSelected]="
                        searchService.searches[ServiceType.Rail].isRailHotelComboSearch
                      "
                      [isComboButton]="true"
                      (selected)="toggleRailHotelCombo()"
                    >
                      <div class="item-label" aria-hidden="true">
                        <i class="ico-rail" aria-hidden="true"></i>
                        <span id="booking-options-{{ ServiceType.Rail }}-combo">
                          @if (!hasTrainline) {
                            <span i18n="@@searchRail">UK Rail</span>
                          } @else {
                            <span i18n="@@ProfileInformation-Rail">Rail</span>
                          }
                        </span>
                        <span aria-label="plus">+</span>
                        <i class="ico-bed" aria-hidden="true"></i>
                        <span
                          id="booking-options-{{ ServiceType.Hotel }}-{{ ServiceType.Rail }}-combo"
                          i18n="@@searchHotel"
                          >Hotel</span
                        >
                      </div>
                    </app-product-checkbox>
                  }

                  @if (
                    data?.services?.[ServiceType.Flight] && data?.services?.[ServiceType.Hotel]
                  ) {
                    <app-product-checkbox
                      class="booking_options_option"
                      [service]="ServiceType.Flight"
                      [disabled]="
                        !data.services?.[ServiceType.Flight] ||
                        !data.services?.[ServiceType.Hotel] ||
                        paymentRestrictions[ServiceType.Flight] ||
                        paymentRestrictions[ServiceType.Hotel]
                      "
                      [isPaymentRestrictedDueToNoCard]="
                        paymentRestrictions[ServiceType.Flight] ||
                        paymentRestrictions[ServiceType.Hotel]
                      "
                      [comboSelected]="
                        searchService.searches[ServiceType.Flight]?.isFlightHotelComboSearch
                      "
                      [isComboButton]="true"
                      (selected)="toggleFlightHotelCombo()"
                    >
                      <div class="item-label" aria-hidden="true">
                        <i class="ico-flight" aria-hidden="true"></i>
                        <span
                          id="booking-options-{{ ServiceType.Flight }}-combo"
                          i18n="@@searchFlight"
                          >Flight</span
                        >
                        <span aria-label="plus">+</span>
                        <i class="ico-bed" aria-hidden="true"></i>
                        <span
                          id="booking-options-{{ ServiceType.Hotel }}-{{
                            ServiceType.Flight
                          }}-combo"
                          i18n="@@searchHotel"
                          >Hotel</span
                        >
                      </div>
                    </app-product-checkbox>
                  }
                </div>
              }
              <div class="booking_options">
                @if (showUnavailableServices || data?.services?.[ServiceType.Flight]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Flight"
                    [disabled]="
                      !data.services?.[ServiceType.Flight] ||
                      paymentRestrictions[ServiceType.Flight]
                    "
                    [disableGroup]="
                      searchService.searches[ServiceType.Flight]?.isFlightHotelComboSearch
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Flight]"
                    (selected)="toggleOptionAttempt(ServiceType.Flight)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-flight"></i>
                      <span id="booking-options-{{ ServiceType.Flight }}" i18n="@@searchFlight"
                        >Flight</span
                      >
                    </div>
                  </app-product-checkbox>
                }

                <!-- For now just place in all four options, determine which are used by the user later, hardcoded for now -->
                @if (showUnavailableServices || data?.services?.[ServiceType.Rail]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Rail"
                    [disabled]="
                      !data.services?.[ServiceType.Rail] || paymentRestrictions[ServiceType.Rail]
                    "
                    [disableGroup]="searchService.searches[ServiceType.Rail].isRailHotelComboSearch"
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Rail]"
                    (selected)="toggleOptionAttempt(ServiceType.Rail)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-rail" aria-hidden="true"></i>
                      <span id="booking-options-{{ ServiceType.Rail }}">
                        @if (!hasTrainline) {
                          <span i18n="@@searchRail">UK Rail</span>
                        } @else {
                          <span i18n="@@ProfileInformation-Rail">Rail</span>
                        }
                      </span>
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.Eurostar]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Eurostar"
                    [disabled]="
                      !data.services?.[ServiceType.Eurostar] ||
                      paymentRestrictions[ServiceType.Eurostar]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Eurostar]"
                    (selected)="toggleOptionAttempt(ServiceType.Eurostar)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="custom_icon-eurostar" aria-hidden="true"></i>
                      <span id="booking-options-{{ ServiceType.Eurostar }}" i18n="@@searchEurostar"
                        >Eurostar
                      </span>
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.Hotel]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Hotel"
                    [disabled]="
                      !data.services?.[ServiceType.Hotel] || paymentRestrictions[ServiceType.Hotel]
                    "
                    [disableGroup]="
                      searchService.searches[ServiceType.Flight]?.isFlightHotelComboSearch ||
                      searchService.searches[ServiceType.Rail].isRailHotelComboSearch
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Hotel]"
                    (selected)="toggleOptionAttempt(ServiceType.Hotel)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-bed" aria-hidden="true"></i>
                      <span id="booking-options-{{ ServiceType.Hotel }}" i18n="@@searchHotel"
                        >Hotel</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.LongStays]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.LongStays"
                    [disabled]="
                      !data.services?.[ServiceType.LongStays] ||
                      paymentRestrictions[ServiceType.LongStays]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.LongStays]"
                    (selected)="toggleOptionAttempt(ServiceType.LongStays)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="custom_icon-apartment" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.LongStays }}"
                        i18n="@@searchLongStays"
                        >Long Stays</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data.services?.[ServiceType.Car]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Car"
                    [disabled]="
                      !data.services?.[ServiceType.Car] || paymentRestrictions[ServiceType.Car]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Car]"
                    (selected)="toggleOptionAttempt(ServiceType.Car)"
                  >
                    <div class="item-label">
                      <i class="ico-car" aria-hidden="true"></i>
                      <span id="booking-options-{{ ServiceType.Car }}" i18n="@@searchCar">Car</span>
                    </div>
                  </app-product-checkbox>
                }

                @if (showUnavailableServices || data?.services?.[ServiceType.FastTrack]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.FastTrack"
                    [disabled]="
                      !data.services?.[ServiceType.FastTrack] ||
                      paymentRestrictions[ServiceType.FastTrack]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.FastTrack]"
                    (selected)="toggleOptionAttempt(ServiceType.FastTrack)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-fast-track ico-material" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.FastTrack }}"
                        i18n="@@searchAirportFastTrack"
                        >Fast Track</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.Lounge]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Lounge"
                    [disabled]="
                      !data.services?.[ServiceType.Lounge] ||
                      paymentRestrictions[ServiceType.Lounge]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Lounge]"
                    (selected)="toggleOptionAttempt(ServiceType.Lounge)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-lounge ico-material" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.Lounge }}"
                        i18n="@@searchAirportLounge"
                        >Lounge</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.Parking]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Parking"
                    [disabled]="
                      !data.services?.[ServiceType.Parking] ||
                      paymentRestrictions[ServiceType.Parking]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Parking]"
                    (selected)="toggleOptionAttempt(ServiceType.Parking)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-parking ico-material" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.Parking }}"
                        i18n="@@searchAirportParking"
                        >Parking</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data.services?.[ServiceType.Cab]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Cab"
                    [disabled]="
                      !data.services?.[ServiceType.Cab] || paymentRestrictions[ServiceType.Cab]
                    "
                    [isPaymentRestrictedDueToNoCard]="paymentRestrictions[ServiceType.Cab]"
                    (selected)="toggleOptionAttempt(ServiceType.Cab)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-taxi" aria-hidden="true"></i>
                      <span id="booking-options-{{ ServiceType.Cab }}" i18n="@@searchTaxi"
                        >Taxi</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data.services?.[ServiceType.Ferry]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Ferry"
                    [disabled]="!data.services?.[ServiceType.Ferry]"
                    (selected)="toggleOptionAttempt(ServiceType.Ferry)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-ferries" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.Ferry }}"
                        i18n="@@searchFerryEurotunnel"
                        >Ferry/Eurotunnel</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.SeasonTicket]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.SeasonTicket"
                    [disabled]="!data.services?.[ServiceType.SeasonTicket]"
                    (selected)="toggleOptionAttempt(ServiceType.SeasonTicket)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="custom_icon-season-tickets" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.SeasonTicket }}"
                        i18n="@@searchSeasonTickets"
                        >Season Tickets</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.MeetingRoom]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.MeetingRoom"
                    [disabled]="!data.services?.[ServiceType.MeetingRoom]"
                    (selected)="toggleOptionAttempt(ServiceType.MeetingRoom)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-calendar" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.MeetingRoom }}"
                        i18n="@@searchMeetingRoom"
                        >Meeting Room</span
                      >
                    </div>
                  </app-product-checkbox>
                }
                @if (showUnavailableServices || data?.services?.[ServiceType.Ambulance]) {
                  <app-product-checkbox
                    class="booking_options_option"
                    [service]="ServiceType.Ambulance"
                    [disabled]="!data.services?.[ServiceType.Ambulance]"
                    (selected)="toggleOptionAttempt(ServiceType.Ambulance)"
                  >
                    <div class="item-label" aria-hidden="true">
                      <i class="ico-ambulance ico-material" aria-hidden="true"></i>
                      <span
                        id="booking-options-{{ ServiceType.Ambulance }}"
                        i18n="@@searchAmbulance"
                        >Ambulance</span
                      >
                    </div>
                  </app-product-checkbox>
                }
              </div>
            </div>
          }
          @if (passportErrors.length) {
            <div role="alert">
              @for (passportError of passportErrors; track passportError) {
                <div class="passport_error" id="passport_error_message">
                  {{ passportError }}
                </div>
              }
            </div>
          }
          @if (
            searchService?.search_objects?.[ServiceType.Rail]?.priority ===
              searchService?.highest_search_priority &&
            !searchService?.searches?.[ServiceType.Flight]?.railFromFlightSearchPerformed
          ) {
            <span>
              @for (railcardError of railcardErrors; track railcardError) {
                <div class="passport_error" id="passport_error_message">
                  {{ railcardError }}
                </div>
              }
            </span>
          }
        </section>
        <!-- show menu if small screen less then 1600 -->
        <div class="menu-small-screen">
          <ng-container
            *ngTemplateOutlet="sideMenuTemplate; context: { suffix: '-small' }"
          ></ng-container>
        </div>
      </div>

      <div class="search-container">
        <section
          class="app-left booking_panel_forms background-container-background secondary-text-colour"
        >
          @if (show_errors) {
            <div class="form_validation" id="error-message-list">
              <span
                role="alert"
                id="error-alert"
                class="visuallyhidden"
                style="display: none"
                tabindex="0"
                >There are errors on the page</span
              >
              <h2 class="visuallyhidden">There are errors on the page</h2>
              <div>
                @for (error of data.errors; track error; let i = $index) {
                  <div class="validation_error">
                    <span id="error-{{ i }}">{{ error | translate }}</span>
                  </div>
                }
              </div>
            </div>
          }
          <div class="search_container" [ngClass]="{ errored_search_container: show_errors }">
            <form autocomplete="off" #searchForm>
              @if (data.allUserdata) {
                <app-add-travellers
                  id="add-travellers"
                  [(showGuestTravellerForm)]="showGuestTravellerForm"
                  (showRightPanelMenu)="setRightPanelItem($event)"
                  (loadingTravellerProfile)="setLoadingTravellerProfile($event)"
                ></app-add-travellers>
              }

              @if (!showGuestTravellerForm && data.services) {
                <div class="clearfix">
                  @if (
                    searchService?.search_objects?.[ServiceType.Flight]?.priority ===
                      searchService?.highest_search_priority &&
                    !searchService?.searches?.[ServiceType.Rail]?.isRailHotelComboSearch
                  ) {
                    <app-flight-search
                      (toggleHotelSearchRequested)="toggleHotelSearchRequested($event)"
                    >
                    </app-flight-search>
                  }

                  @if (
                    searchService?.searches?.[ServiceType.Rail]?.isRailHotelComboSearch ||
                    (searchService?.search_objects?.[ServiceType.Rail]?.priority ===
                      searchService?.highest_search_priority &&
                      !searchService?.searches?.[ServiceType.Flight]?.railFromFlightSearchPerformed)
                  ) {
                    <app-rail-search
                      (toggleHotelSearchRequested)="toggleHotelSearchRequested($event)"
                    >
                    </app-rail-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.InternationalRail]?.priority ===
                      searchService?.highest_search_priority &&
                    searchService?.search_objects?.[ServiceType.InternationalRail]?.chosen
                  ) {
                    <app-irl-search> </app-irl-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Hotel]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-hotel-search> </app-hotel-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Car]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-car-search
                      (toggleHotelSearchRequested)="toggleHotelSearchRequested($event)"
                    >
                    </app-car-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Eurostar]?.priority ===
                      searchService?.highest_search_priority &&
                    !searchService?.searches?.[ServiceType.Flight]
                      ?.eurostarFromFlightSearchPerformed
                  ) {
                    <app-eurostar-search
                      (toggleHotelSearchRequested)="toggleHotelSearchRequested($event)"
                    >
                    </app-eurostar-search>
                  }

                  @if (
                    searchService?.search_objects?.[ServiceType.Lounge]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-lounge-search> </app-lounge-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Parking]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-parking-search> </app-parking-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.FastTrack]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-fast-track-search> </app-fast-track-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Cab]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-taxi-search> </app-taxi-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Ferry]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-ferry-search> </app-ferry-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.LongStays]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-apartment-search> </app-apartment-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.SeasonTicket]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-season-tickets-search> </app-season-tickets-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.MeetingRoom]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-meeting-room-search> </app-meeting-room-search>
                  }
                  @if (
                    searchService?.search_objects?.[ServiceType.Ambulance]?.priority ===
                    searchService?.highest_search_priority
                  ) {
                    <app-ambulance-search> </app-ambulance-search>
                  }
                  <div
                    class="flex-row-container flex-row-container--right button-container flex-column-mobile"
                  >
                    @if (
                      selectedOptions().length &&
                      selectedServiceIsNotOfflineBooking &&
                      !searchService.searches[ServiceType.Flight]?.isFlightHotelComboSearch &&
                      !searchService.searches[ServiceType.Rail].isRailHotelComboSearch
                    ) {
                      <app-add-to-favorites
                        [serviceType]="serviceType"
                        (showErrors)="show_errors = $event"
                      >
                      </app-add-to-favorites>
                    }
                    @if (
                      selectedOptions().length &&
                      !(
                        searchService?.searches?.[ServiceType.InternationalRail] &&
                        searchService?.searches?.[ServiceType.InternationalRail].offlineRequest &&
                        selectedOptions().length &&
                        searchService?.search_objects?.[ServiceType.InternationalRail]?.priority ===
                          searchService?.highest_search_priority
                      ) &&
                      searchService?.search_objects?.[ServiceType.Ferry]?.priority !==
                        searchService?.highest_search_priority &&
                      searchService?.search_objects?.[ServiceType.SeasonTicket]?.priority !==
                        searchService?.highest_search_priority &&
                      searchService?.search_objects?.[ServiceType.MeetingRoom]?.priority !==
                        searchService?.highest_search_priority &&
                      searchService?.search_objects?.[ServiceType.Ambulance]?.priority !==
                        searchService?.highest_search_priority &&
                      !searchService?.isFavoritesSelected
                    ) {
                      <button
                        type="button"
                        id="search-all"
                        (click)="fetchSearchAll()"
                        [disabled]="searchService?.highest_search_priority < 1 || data.loadingDate"
                        appButton="large-search"
                      >
                        @if (
                          searchService?.search_objects?.[ServiceType.LongStays]?.priority !==
                          searchService?.highest_search_priority
                        ) {
                          <span i18n="@@search_Search"> Search </span>
                        }
                        @if (
                          searchService?.search_objects?.[ServiceType.LongStays]?.priority ===
                          searchService?.highest_search_priority
                        ) {
                          <span i18n="@@search_submitform">Submit Form</span>
                        }
                      </button>
                    }
                    @if (
                      (selectedOptions().length &&
                        searchService?.searches?.[ServiceType.InternationalRail] &&
                        searchService?.searches?.[ServiceType.InternationalRail].offlineRequest &&
                        selectedOptions().length &&
                        searchService?.search_objects?.[ServiceType.InternationalRail]?.priority ===
                          searchService?.highest_search_priority) ||
                      searchService?.search_objects?.[ServiceType.Ferry]?.priority ===
                        searchService?.highest_search_priority ||
                      searchService?.search_objects?.[ServiceType.SeasonTicket]?.priority ===
                        searchService?.highest_search_priority ||
                      searchService?.search_objects?.[ServiceType.MeetingRoom]?.priority ===
                        searchService?.highest_search_priority ||
                      searchService?.search_objects?.[ServiceType.Ambulance]?.priority ===
                        searchService?.highest_search_priority
                    ) {
                      <button
                        type="button"
                        id="submit-all"
                        (click)="fetchSearchAll()"
                        [disabled]="
                          searchService?.highest_search_priority < 1 || loadingOfflineRequestDialog
                        "
                        appButton="large-search"
                        i18n="@@search_submit"
                      >
                        Submit
                      </button>
                    }
                  </div>
                </div>
              }
            </form>
          </div>
        </section>
        <!-- show menu if large screen more then 1600 -->
        <div class="menu-large-screen">
          <ng-container
            *ngTemplateOutlet="sideMenuTemplate; context: { suffix: '-large' }"
          ></ng-container>
        </div>
      </div>

      @if (becomingUser()) {
        <app-loading-screen>
          <span title i18n="@@mainBecomingUser">Becoming User ...</span>
        </app-loading-screen>
      }
    </div>
  }
</div>
